<template>
	<div class="row text-center" v-if="items.length > per_page">
		<nav aria-label="Page navigation">
			<ul class="pagination">
				<li class="pointer disabled" v-if="$route.query.page == 1">
					<span aria-hidden="true">&laquo;</span>
				</li>
				<li class="pointer" v-if="$route.query.page > 1">
					<a @click="changePage(parseInt($route.query.page) - 1)" aria-label="Previous">
						<span aria-hidden="true">&laquo;</span>
					</a>
				</li>
				<li class="pointer"><a v-for="n in render_offset | offset" track-by="$index" @click="changePage(n + 1)" :class="{ 'active': (n + 1) == $route.query.page }">{{ n + 1 }}</a></li>
				<li class="pointer" v-if="$route.query.page < render_offset">
					<a @click="changePage(parseInt($route.query.page) + 1)" aria-label="Next">
						<span aria-hidden="true">&raquo;</span>
					</a>
				</li>
				<li class="pointer disabled" v-if="$route.query.page == render_offset">
					<span aria-hidden="true">&raquo;</span>
				</li>
			</ul>
		</nav>
		<!-- <div class="pagination-text">Mostrando página {{ $route.query.page }} de {{ Math.ceil(render_offset) }}</div> -->
	</div>
</template>

<style scoped>
.active {
	background-color: #000;
	color: white;
}

.disabled span {
	border-color: #bbb !important;
	color: #bbb;
}
</style>

<script>
import { router } from '../routes/routes';
export default {
	props: ['url', 'items', 'per_page'],

	data() {
		return {}
	},

	computed: {
		render_offset () {
			return Math.ceil(this.items.length / this.per_page);
		}
	},

	filters: {
		offset (number) {
			let diff = 4;
			let numbers = [];
			let page = this.$route.query.page;

			if (parseInt(page) + diff > Math.ceil(this.items.length / this.per_page)) {
				for (let i = 0, n = number; i < n; i++) {
					numbers.push(i);
				}

				return numbers.slice((diff + 1) * -1);
			}

			for (let i = (page - 1), n = number; i < parseInt(page) + diff; i++) {
				numbers.push(parseInt(i));
			}

			return numbers;
		}
	},

	methods: {
		changePage (page_num) {
			let url = this.url + page_num;
			// check if the page num is in the limit.
			if (page_num < 1 || page_num > Math.ceil(this.items.length / this.per_page)) {
				return;
			}

			if (this.$route.query.filter) {
				url += '&filter=' + this.$route.query.filter;
			}

			if (this.$route.query.search) {
				url += '&search=' + this.$route.query.search;
			}

			router.go({ path: url });
		}
	}
}
</script>


// WEBPACK FOOTER //
// Pagination.vue?3af83311